import "regenerator-runtime/runtime"
import React from 'react'
import ReactDOM from 'react-dom'
import App from './landing/App'
ErrorBoundary = bugsnag.getPlugin('react')

ReactDOM.render(
	<ErrorBoundary>
		<App />
	</ErrorBoundary>,
	document.getElementById('root')
)
